export class RdExaminationDetails {
  date: string;
  signatoryFirstName: string;
  signatoryLastName: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  taxYear: string;
  programManagerName: string;
  programManagerEmail: string;
  managerMessage: string;
}
